import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import {
  Close as CloseIcon,
  Warning as WarningIcon,
  Refresh as RefreshIcon,
  Info as InfoIcon,
  AccessTime as ClockIcon,
} from '@mui/icons-material';

/**
 * Location Warning Dialog Component
 * Shows when lab and app locations are more than 1km apart
 */
export const LocationWarningDialog = ({ open, onClose, distanceMessage }) => {
 const onLocationRecheck = () => {
    window.location.reload();
  };
  return (
    <Dialog
      open={open}
      //onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: 24,
        },
      }}
    >
      <DialogTitle
        sx={{
          background: 'linear-gradient(135deg, #ff9800 0%, #f44336 100%)',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          py: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon />
          <Typography variant="h6" component="span">
            Location Warning
          </Typography>
        </Box>
        {/* <IconButton
          onClick={onClose}
          sx={{
            color: 'white',
            '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' },
          }}
        >
          <CloseIcon />
        </IconButton> */}
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Alert severity="warning" sx={{ mb: 2 }}>
          {distanceMessage || 'Location discrepancy detected'}
        </Alert>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onLocationRecheck}
          variant="contained"
          startIcon={<RefreshIcon />}
          sx={{
            background: 'linear-gradient(135deg, #ff9800 0%, #f44336 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #f57c00 0%, #d32f2f 100%)',
            },
          }}
        >
          Recheck
        </Button>
        {/* <Button
          onClick={onClose}
          variant="contained"
          sx={{
            background: 'linear-gradient(135deg, #ff9800 0%, #f44336 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #f57c00 0%, #d32f2f 100%)',
            },
          }}
        >
          Close
        </Button> */}
      </DialogActions>
    </Dialog>
  );
};

/**
 * Hourly Attendance Check Dialog Component
 * Shows when hourly attendance is not marked
 */
export const HourlyAttendanceDialog = ({ open, onClose, message, onRecheck }) => {
   const handleRecheck = () => {
    window.location.reload();
  };
  return (
    <Dialog
      open={open}
      //onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: 24,
        },
      }}
    >
      <DialogTitle
        sx={{
          background: 'linear-gradient(135deg, #ff9800 0%, #f44336 100%)',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          py: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ClockIcon />
          <Typography variant="h6" component="span">
            It’s time to take your selfie.
          </Typography>
        </Box>
        {/* <IconButton
          onClick={onClose}
          sx={{
            color: 'white',
            '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' },
          }}
        >
          <CloseIcon />
        </IconButton> */}
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Box
          sx={{
            p: 2,
            bgcolor: 'grey.100',
            borderRadius: 1,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1,
          }}
        >
          <InfoIcon color="info" sx={{ mt: 0.5 }} />
          <Typography variant="body2" color="text.secondary">
            You are requested to open the mobile application and capture your selfie.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        {/* <Button onClick={onClose} variant="outlined">
          Close
        </Button> */}
        <Button
          onClick={handleRecheck}
          onRecheck={handleRecheck}
          variant="contained"
          startIcon={<RefreshIcon />}
          sx={{
            background: 'linear-gradient(135deg, #ff9800 0%, #f44336 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #f57c00 0%, #d32f2f 100%)',
            },
          }}
        >
          Recheck
        </Button>
      </DialogActions>
    </Dialog>
  );
};
